import styled, { css } from 'styled-components';

export const StyledSearchBarWrapper = styled.div<{ borderRadius?: string }>`
  display: flex;
  /* align-items: center; */
  height: fit-content;
  flex-wrap: nowrap;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.white};
  cursor: pointer;
  user-select: none;
  border-radius: ${({ borderRadius }) => borderRadius || '0'};
  overflow: hidden;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding: 20px 0px;
  }
`;

export const SearchBarInputWrapper = styled.div<{
  wrapperPadding?: string;
  isHomePage?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  height: fit-content;
  flex-wrap: nowrap;
  border-radius: ${({ isHomePage }) => (isHomePage ? '0' : '8px')};
  overflow: hidden;
  padding: ${({ wrapperPadding }) => wrapperPadding || '17px'};
`;

export const SearchBarLabel = styled.div<{
  isActive?: boolean;
  isFilled?: boolean;
}>`
  ${({ isFilled, isActive }) =>
    !isActive &&
    isFilled &&
    css`
      opacity: 0.5;
    `};
  font-size: 12px;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const SearchBarInputText = styled.div<{
  isActive?: boolean;
  isFilled?: boolean;
}>`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.matterHorn};
  text-overflow: inherit;
  white-space: inherit;
  overflow: inherit;
  ${({ isFilled, isActive }) =>
    !isActive &&
    !isFilled &&
    css`
      opacity: 0.5;
      font-weight: normal;
    `};
`;

export const IconRightSpace = styled.div`
  width: 15px;
`;

export const InputContentWrapper = styled.div`
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const RenderOverlayContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  cursor: auto;
  border-radius: 8px;
  overflow: hidden;
  .setur-list-split {
    .setur-list-item {
      padding-left: 20px;
      border-bottom: none;
    }
  }
`;

SearchBarLabel.defaultProps = {
  isActive: false,
};
